/* eslint-disable no-redeclare */
/* Type Script Utils */

/* eslint-disable prefer-arrow/prefer-arrow-functions */
/**
 * Helper for safe keys enumeration.
 *
 * Let's imagine that we have an interface the next interface:
 *
 *   interface User {
 *     id: number;
 *     name?: string;
 *     email: string;
 *   }
 *
 * And we have a JSON Schema that describes the user entities.
 *
 *   {
 *     type: 'object
 *     properties: ...,
 *     required: ['id', 'e-mail'],      <--- a typo in the User.email field that the typescript will not show
 *   }
 *
 * We can avoid mistakes like this by wrapping the keys array by {@link safeKeys}.
 * Look at the example:
 *
 *   {
 *     ...
 *     required: safeKeys<User>[
 *       'id',
 *       'e-mail',               //  <--- Error:(41, 5) TS2345: Argument of type '"e-mail"[]'
 *     ],                        //           is not assignable to parameter of type '("id" | "name" | "email")[]'.
 *                               //         Type '"e-mail"' is not assignable to type '"id" | "name" | "email"'.
 *   }
 *
 */
export function safeKeys<T extends object>(keys: (keyof T)[]): (keyof T)[];
export function safeKeys<T extends string>(keys: T[]): T[];
export function safeKeys(keys: string[]): string[] {
  return keys;
}

/**
 * Helper for safely specifying a name of a key.
 *
 * @see {@link safeKeys} for details. It works like that, but for only one key
 *
 * @example
 *
 *   interface User {
 *     id: number;
 *     name?: string;
 *     email: string;
 *   }
 *
 *   const group = new FormGroup( ... );
 *   ...
 *   const emailControl = group.get(safeKey<User>('email'));
 *
 */
export function safeKey<T extends object>(keys: keyof T): keyof T;
export function safeKey<T extends string>(keys: T): T;
export function safeKey(key: string): string {
  return key;
}
/* eslint-enable prefer-arrow/prefer-arrow-functions */
